module.exports = __webpack_public_path__ + "static/media/scooter.0fbc40f6.png";